import { Component, OnInit, Input, HostListener } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';

@Component({
  selector: 'app-r-q9',
  templateUrl: './r-q9.component.html',
  styleUrls: ['./r-q9.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ9Component implements OnInit {
  @Input() data: any;
  property;
  isDisable;
  hgProperty;
  isChecked = false;
  showbutton = true;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  home_types;
  messagetype;
  deviceWidth;
  user_bot = false;
  prop1_id;
  prop2_id;
  prop3_id;
  prop4_id;
  timer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    this.hgProperty = {
      prop1: false,
      prop2: false,
      prop3: false,
      prop4: false,
    };
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler($event) {
    this.residentialService.updateNotificationDetails(
      this.residentialService.notificationObj
    );
  }

  goNext() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ nextId: '0014' });
    }
    if (this.deviceWidth < 768) {
      this.prop1_id = document.getElementById('home1_mob');
      this.prop2_id = document.getElementById('home2_mob');
      this.prop3_id = document.getElementById('home3_mob');
      this.prop4_id = document.getElementById('home4_mob');
    } else {
      this.prop1_id = document.getElementById('home1');
      this.prop2_id = document.getElementById('home2');
      this.prop3_id = document.getElementById('home3');
      this.prop4_id = document.getElementById('home4');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    this.userResponses = this.residentialService.userResponse.userResponses;
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        res_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.property = obj.fieldValue;
        this.isChecked = true;
        if (!_.isEmpty(this.property)) {
          if (this.property === 'Single family home') {
            this.hgProperty = {
              prop1: true,
              prop2: false,
              prop3: false,
              prop4: false,
            };
            this.prop1_id.parentElement.classList.add('active-select');
          } else if (this.property === 'Apartment or condominium') {
            this.hgProperty = {
              prop1: false,
              prop2: true,
              prop3: false,
              prop4: false,
            };
            this.prop2_id.parentElement.classList.add('active-select');
          } else if (this.property === 'Townhouse') {
            this.hgProperty = {
              prop1: false,
              prop2: false,
              prop3: true,
              prop4: false,
            };
            this.prop3_id.parentElement.classList.add('active-select');
          } else if (this.property === 'Manufactured home') {
            this.hgProperty = {
              prop1: false,
              prop2: false,
              prop3: false,
              prop4: true,
            };
            this.prop4_id.parentElement.classList.add('active-select');
          }
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    if(!this.hgProperty.prop1 && !this.hgProperty.prop2 && !this.hgProperty.prop3 && !this.hgProperty.prop4 )
    {
      this.showbutton = false;
    }
  }

  getProperty(event) {
    this.property = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        // console.log.log(this.deviceWidth);
        this.residentialService.unSelectService({ currentId: this.data });
      }
      if (!_.isEmpty(this.property)) {
        this.user_bot = true;
        if (this.property === 'Single family home') {
          this.hgProperty = {
            prop1: true,
            prop2: false,
            prop3: false,
            prop4: false,
          };
          if (
            _.contains(this.prop2_id.parentElement.classList, 'active-select')
          ) {
            this.prop2_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop3_id.parentElement.classList, 'active-select')
          ) {
            this.prop3_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop4_id.parentElement.classList, 'active-select')
          ) {
            this.prop4_id.parentElement.classList.remove('active-select');
          }
          this.prop1_id.parentElement.classList.add('active-select');
        } else if (this.property === 'Apartment or condominium') {
          this.hgProperty = {
            prop1: false,
            prop2: true,
            prop3: false,
            prop4: false,
          };
          this.prop2_id.parentElement.classList.add('active-select');
          if (
            _.contains(this.prop1_id.parentElement.classList, 'active-select')
          ) {
            this.prop1_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop3_id.parentElement.classList, 'active-select')
          ) {
            this.prop3_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop4_id.parentElement.classList, 'active-select')
          ) {
            this.prop4_id.parentElement.classList.remove('active-select');
          }
        } else if (this.property === 'Townhouse') {
          this.hgProperty = {
            prop1: false,
            prop2: false,
            prop3: true,
            prop4: false,
          };
          this.prop3_id.parentElement.classList.add('active-select');
          if (
            _.contains(this.prop1_id.parentElement.classList, 'active-select')
          ) {
            this.prop1_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop2_id.parentElement.classList, 'active-select')
          ) {
            this.prop2_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop4_id.parentElement.classList, 'active-select')
          ) {
            this.prop4_id.parentElement.classList.remove('active-select');
          }
        } else if (this.property === 'Manufactured home') {
          this.hgProperty = {
            prop1: false,
            prop2: false,
            prop3: false,
            prop4: true,
          };
          this.prop4_id.parentElement.classList.add('active-select');
          if (
            _.contains(this.prop1_id.parentElement.classList, 'active-select')
          ) {
            this.prop1_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop3_id.parentElement.classList, 'active-select')
          ) {
            this.prop3_id.parentElement.classList.remove('active-select');
          }
          if (
            _.contains(this.prop2_id.parentElement.classList, 'active-select')
          ) {
            this.prop2_id.parentElement.classList.remove('active-select');
          }
        }
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      this.hgProperty = {
        prop1: false,
        prop2: false,
        prop3: false,
        prop4: false,
      };
      if (_.contains(this.prop1_id.parentElement.classList, 'active-select')) {
        this.prop1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.prop3_id.parentElement.classList, 'active-select')) {
        this.prop3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.prop2_id.parentElement.classList, 'active-select')) {
        this.prop2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.prop4_id.parentElement.classList, 'active-select')) {
        this.prop4_id.parentElement.classList.remove('active-select');
      }
      this.property = '';
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
      this.user_bot = false;
    }
    this.save();
    if (this.deviceWidth < 768) {
      
    }else
    {
      if (this.isChecked === true) {
        if(!this.showbutton)
        {
          this.next();
        }
      }
    }
  
  }

  next() {
    if (_.isEmpty(this.property)) {
      // console.log.log(this.property);
      // alert('Select the Home type');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
    } else {
      this.residentialService.property = this.property;
      this.residentialService.messageService({ currentId: this.data });
    }
    const notificationObj = {
      questionnairePercent: this.residentialService.questionPercentage,
      percentage: this.residentialService.questionPercentage,
    };
    this.residentialService.notificationObj = {
      ...this.residentialService.notificationObj,
      ...notificationObj,
    };
  }

  // This function is used for to save the data in DB
  save() {
    const Obj = {
      res_question_id: this.data,
      fieldName: 'property',
      fieldValue: this.property,
    };
    this.residentialService.updateResponses(Obj);
  }
}
